// extracted by mini-css-extract-plugin
module.exports = {"Home":"Home_Home__EwjGr","Heading":"Home_Heading__I83sd"};